// main package assets (transitively base, theming and icons)
import "@ui5/webcomponents/dist/Assets.js";

// own fiori package assets
import "./generated/json-imports/Themes.js";
import "./generated/json-imports/i18n.js";
